export default __webpack_public_path__ + "static/media/icon-awaiting.c483978c.svg";